var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_12060)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00539F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9762 14.2536C28.5829 14.2536 27.2467 13.7001 26.2615 12.7148C25.2763 11.7296 24.7228 10.3933 24.7229 9.00003H20.9695V23.6974C20.9688 24.3675 20.7572 25.0204 20.3648 25.5635C19.9723 26.1066 19.4188 26.5124 18.7828 26.7234C18.1468 26.9344 17.4605 26.9399 16.8212 26.7391C16.182 26.5383 15.6221 26.1413 15.221 25.6045C14.8199 25.0677 14.5979 24.4183 14.5865 23.7483C14.5751 23.0784 14.7749 22.4218 15.1575 21.8717C15.5401 21.3215 16.0862 20.9058 16.7183 20.6834C17.3504 20.4609 18.0364 20.4431 18.6792 20.6323V16.9837C17.3132 16.7995 15.9234 17.0365 14.6955 17.6629C13.4677 18.2894 12.4601 19.2755 11.8074 20.4896C11.1548 21.7038 10.888 23.0881 11.0429 24.4578C11.1977 25.8275 11.7667 27.1174 12.6739 28.1553C13.5811 29.1931 14.7834 29.9294 16.1201 30.266C17.4568 30.6025 18.8644 30.5233 20.1549 30.0388C21.4454 29.5543 22.5574 28.6877 23.3424 27.5546C24.1273 26.4215 24.5479 25.0759 24.548 23.6974L24.6575 16.2684C26.1997 17.4004 28.0635 18.0096 29.9766 18.0067L29.9762 14.2536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_12060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.8d52e478.svg";
export { ForwardRef as ReactComponent };